import { useCallback } from "react";

function useShowError() {
  const showError = useCallback(() => {}, []);
  return showError;
}

export default useShowError;
